<template>
    <div class=" px-1 ">
        <HeaderBar/>
        <div
          class="d-flex flex-column mb-2 mt-4"
          style="font-size: 15px; font-weight: 500"
        >
            <div class="add-economic-record-title1 mt-2 text-center "> Ingreso por producto</div>
        </div>
        <div class="d-flex flex-column">
            <validation-observer ref="GanForm">
                <div >
                    <b-form @submit.prevent="">
                        <!-- date -->
                        <b-form-group label="Fecha">
                            <validation-provider
                            #default="{ errors }" 
                            name="Fecha" 
                            rules="required">
                                <b-form-datepicker v-model="economic.date" class="form-control" 
                                :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                :min="minCfgDate" :max="maxCfgDate"/>
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                        <b-form-group label="Tipo de Producto" label-for="product">
                            <validation-provider
                            #default="{ errors }" 
                            name="Producto" 
                            rules="required">
                                <b-form-select  v-model="economic.product_id" :options="productsOptions" :values="productsOptions.value" label="text"/>
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>  
                        </b-form-group>
                        <b-form-group label="Cantidad" label-for="quantity">
                            <validation-provider 
                            #default="{ errors }" 
                            name="Cantidad" 
                            rules="required">
                                <b-form-input type="number" id="quantity" v-model="economic.unit" class="w-100"
                                    :state="errors.length > 0 ? false : null" name="quantity" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                        <b-form-group label="Monto" label-for="amount">
                            <validation-provider 
                            #default="{ errors }" 
                            name="Monto" 
                            rules="required">
                                <b-form-input type="number" id="amount" v-model="economic.amount" class="w-100"
                                    :state="errors.length > 0 ? false : null" name="amount" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                        <b-form-group label="# de Comprobante" label-for="voucher">
                            <validation-provider #default="{ errors }" name="voucher" rules="required">
                                <b-form-input id="voucher" v-model="economic.voucher_num" class="w-100"
                                    :state="errors.length > 0 ? false : null" name="voucher" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                        <!-- <div class="d-flex justify-content-center">
                            <b-img src="@/assets/images/ganImage/UpoladImage.png"></b-img>
                        </div> -->
                        <!-- submit buttons -->
                        <div class="d-flex justify-content-center ">
                            <b-button @click="insertEconomic"
                                class="bg-primary w-75" >
                                Cargar Ingreso 
                            </b-button>
                        </div>
                    </b-form>
                </div>
            </validation-observer>
        </div>
        <ControlMenu />
    </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import axios from 'axios'
import { BButton, BImg, BLink, BFormSelect, BFormDatepicker,BForm, BFormGroup, BFormInput, } from 'bootstrap-vue'
import { required } from '@validations'
import ControlMenu from '@/components/ControlMenu.vue'
import HeaderBar from '@/components/HeaderBar.vue'
import "vue-select/dist/vue-select.css";
import flatPickr from 'vue-flatpickr-component'

export default {
    components: {
        required,
        flatPickr,
        ValidationProvider,
        ValidationObserver,
        BLink,
        BImg,
        BForm,
        BButton,
        BFormSelect,
        BFormGroup,
        BFormInput,
        ControlMenu,
        BFormDatepicker,
        HeaderBar
    },
    data() {
        const now = new Date()
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
        // 15th two months prior
        const minDate = new Date(today)
        minDate.setMonth(minDate.getMonth() - 200)
        minDate.setDate(15)
        // 15th in two months
        const maxDate = new Date(today)
        maxDate.setMonth
        maxDate.setMonth(maxDate.getMonth())
        maxDate.setDate(maxDate.getDate())
        return {
            productsOptions:[],
            productType:null,
            maxCfgDate:maxDate,
            minCfgDate:minDate,
            economic:{
                date:null,
                unit:0,
                amount:0,
                voucher_num:'',
                total:0,
                type:1,
                record_type:1,
                product_id:null,
                farm_id:localStorage.getItem('currentFarm'),
            }
        }
    },
    methods: {
        async fetcProducts(config){
            fetch(this.$apiUrl+"list/products_types", config)
            .then(response => response.json())
            .then(result => {
                console.log(result.products_types);
                this.productsOptions = result.products_types.map(item => {return {value:item.id,text:item.name}})
            })
        },
        
        insertEconomic(){
            this.$refs.GanForm.validate().then(success => {
                if(success){
                    let self=this;
                    const token = localStorage.getItem("accessToken");
                    const config = {headers: {"X-Authorization": `Bearer ${token}`}};
                    //this.economic.product_id=this.productType.value;
                    this.economic.total=(this.economic.unit*this.economic.amount);
                    let productDesc=this.productsOptions.find(option => option.value === this.economic.product_id);
                    this.economic.description=productDesc.text;
                  
                    this.$http.post("add/economic_records", this.economic, config).then(() => {
                        this.economic={
                            date:null,
                            unit:0,
                            amount:0,
                            voucher_num:'',
                            total:0,
                            type:1,
                            record_type:1,
                            product_id:0
                        }
                        console.log("Economic",this.economic);
                        this.$swal({
                            title: 'Registro económico',
                            text: 'Se insertó registro de ingreso de manera satisfactoria',
                            type: 'success',
                            icon:'success',
                            showCancelButton: false,
                            confirmButtonColor:'#5E8F23',
                            showCloseButton: true,
                            showLoaderOnConfirm: false  
                        }).then(function(){
                            history.back();
                        });
                    }).catch(error => {
                        console.log(error)
                    });
                }
            })
        }       
    },
    created() {
        const token = localStorage.getItem("accessToken");
        const config = {headers: {"X-Authorization": `Bearer ${token}`}};
        this.fetcProducts(config);
    }

}
</script>

<style lang="scss">
.incomeProduct {
    font-weight: 600;
    font-size: 24px;
}
@import '@core/scss/vue/libs/vue-flatpicker.scss';

@import '@core/scss/vue/pages/page-auth.scss';
</style>
